import { render, staticRenderFns } from "./BotaoDiagnosticoSocioambiental.vue?vue&type=template&id=c66fca5c&lang=pug"
import script from "./BotaoDiagnosticoSocioambiental.vue?vue&type=script&lang=js"
export * from "./BotaoDiagnosticoSocioambiental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports